module.exports = __webpack_public_path__ + "img/new-workflow-source.9580d516.png";